import { v5 as uuidv5 } from 'uuid';
import getUuid from 'uuid-by-string';

const getKeyValueAndStoreOriginalValue = (value: string) => {
  const salt = getUuid(value.slice(-5));
  const keyValue = uuidv5(value, salt);
  if (localStorage.getItem(keyValue) !== null) return keyValue;

  localStorage.setItem(keyValue, JSON.stringify(value!));
  return keyValue;
};

const getLinkWithEncryption = (
  constURL: string,
  accountNumber: string,
  issueNumber: string
) => {
  const hashValue = getKeyValueAndStoreOriginalValue(accountNumber);
  return `${constURL}/${hashValue}/${issueNumber}`;
};

export const isPartialPathMatch = (
  paths: string[],
  currentPath: string
): boolean => paths.some((path) => currentPath.includes(path));

export default {
  getKeyValueAndStoreOriginalValue,
  getLinkWithEncryption,
};
